import React from 'react';
import Button from '../Button';
import makeIconName from '../../utils/makeIconName';
import makeText from '../../utils/makeText';
import styles from './index.module.scss';
const ICONS_BY_TYPE = {
    error: 'error',
    warning: 'time_warning',
    success: 'success'
};
const NotifyMessage = ({ onClick, onClose, actionLabel, text, title, status = 'error' }) => {
    const _renderCloseButton = () => {
        if (!onClose) {
            return null;
        }
        return (React.createElement("button", { type: 'button', onClick: onClose, className: styles.closeBtn },
            React.createElement("i", { className: `${makeIconName('cross', 'x24')} ${styles.icon}` })));
    };
    return (React.createElement("div", { className: `${styles.notificationContainer} ${styles[status]}` },
        React.createElement("div", { className: styles.notifyWrap },
            React.createElement("div", { className: styles.leftSection },
                React.createElement("i", { className: `${makeIconName(ICONS_BY_TYPE[status], 'x24')} ${styles.icon}` })),
            React.createElement("div", { className: styles.rightSection },
                React.createElement("span", { className: `${makeText('XL')} ${styles.title}` }, title),
                React.createElement("span", { className: `${makeText('M')} ${styles.text} ${!onClick ? styles.withoutMargin : ''}` }, text),
                onClick && React.createElement(Button, { onClick: onClick, label: actionLabel, type: 'outlineBlack', btnSize: 'S' })),
            _renderCloseButton())));
};
export default NotifyMessage;
